import { render } from "./tableLite.vue?vue&type=template&id=fee63fcc&scoped=true"
import script from "./tableLite.vue?vue&type=script&lang=js"
export * from "./tableLite.vue?vue&type=script&lang=js"

import "./tableLite.vue?vue&type=style&index=0&id=fee63fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee63fcc"]])

export default __exports__